import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  q: '¿Necesito experiencia previa?',
  a: 'No. La guía está pensada para principiantes y te acompaña paso a paso desde cero.'
}, {
  q: '¿Necesito máquinas o un taller?',
  a: 'No. Podés empezar desde casa con materiales simples, moldes básicos y herramientas fáciles de conseguir.'
}, {
  q: '¿Los materiales se consiguen fácil?',
  a: 'Sí. Cemento, yeso, lijas, pinturas, selladores y moldes se consiguen en ferreterías, artísticas, bazares o tiendas online.'
}, {
  q: '¿Puedo vender las piezas que aprenda a hacer?',
  a: 'Sí. La guía está orientada a crear piezas decorativas, souvenirs, velas, sets y productos artesanales que puedas ofrecer desde casa.'
}, {
  q: '¿La guía enseña a vender?',
  a: 'Sí. Incluye una guía de emprendimiento para calcular costos, poner precios, armar combos, vender por Instagram y WhatsApp, tomar pedidos y pedir señas.'
}, {
  q: '¿Es un producto físico?',
  a: 'No. Es un producto digital. Recibís acceso a la guía y los bonos de forma online.'
}, {
  q: '¿También sirve para souvenirs?',
  a: 'Sí. Incluye un bono con +100 ideas de souvenirs y pequeños productos para eventos.'
}, {
  q: '¿Cuándo recibo el acceso?',
  a: 'El acceso es inmediato después de la compra.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-10 sm:py-12 px-4 sm:px-6 lg:px-8 max-w-3xl mx-auto" data-id="element-38">
      <div className="text-center mb-8 sm:mb-10 px-2" data-id="element-39">
        <h2 className="text-3xl sm:text-4xl text-deco-text mb-4 font-bold leading-tight" data-id="element-40">
          Preguntas frecuentes
        </h2>
      </div>

      <div className="space-y-3 sm:space-y-4" data-id="element-41">
        {faqs.map((faq, i) => <motion.div key={i} initial={{
        opacity: 0,
        y: 10
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.4,
        delay: i * 0.1
      }} className="bg-deco-card rounded-[1.5rem] border border-deco-warm overflow-hidden shadow-sm" data-id="element-42">
            <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full px-6 py-5 flex items-center justify-between text-left hover:bg-deco-bg transition-colors" data-id="element-43">
              <span className="font-serif font-bold text-base sm:text-lg text-deco-text pr-6 leading-tight" data-id="element-44">
                {faq.q}
              </span>
              <ChevronDown className={`text-deco-terra shrink-0 transition-transform duration-300 ${openIndex === i ? 'rotate-180' : ''}`} size={24} data-id="element-45" />
            </button>

            <AnimatePresence data-id="element-46">
              {openIndex === i && <motion.div initial={{
            height: 0,
            opacity: 0
          }} animate={{
            height: 'auto',
            opacity: 1
          }} exit={{
            height: 0,
            opacity: 0
          }} transition={{
            duration: 0.3
          }} data-id="element-47">
                  <div className="px-6 pb-6 pt-1 text-deco-text/80 leading-relaxed font-normal text-sm sm:text-base border-t border-deco-warm/50" data-id="element-48">
                    {faq.a}
                  </div>
                </motion.div>}
            </AnimatePresence>
          </motion.div>)}
      </div>
    </section>;
}